
export const SET_RESIDENTIAL_TAB_SITES = 'residential:setResidentialTabSites'
export const SET_RESIDENTIAL_LIVE_DATA = 'residential:setResidentialLiveData'
export const SET_RESIDENTIAL_SITE_DETAILS = 'residential:setSiteDetails'
export const SET_RESIDENTIAL_COMPONENTS = 'residential:setResidentialComponents'